import { API_URL_CANDIDATES_GOOGLE_ONE_TAP } from '../../utillities/APIConstant'
import Client from '../../utillities/Client'

export const submitAuthGoogleOneTapAPI = ({ token, from_product }) => {
  return Client.post<any>(API_URL_CANDIDATES_GOOGLE_ONE_TAP, {
    data: { from_product, token }
  })
}
